import { render } from "./ExcavationData.vue?vue&type=template&id=f1c62c68&scoped=true"
import script from "./ExcavationData.vue?vue&type=script&lang=js"
export * from "./ExcavationData.vue?vue&type=script&lang=js"

import "./ExcavationData.vue?vue&type=style&index=0&id=f1c62c68&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1c62c68"]])

export default __exports__